import { useQuery } from '@tanstack/react-query';
import { getAppApiUrl } from 'api/services';
import { getApiUrl, setApiUrl, setProxyUrl, setSocketUrl } from 'config/api-url';
import { useEffect, useState } from 'react';

const useAppApiUrlData = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const query = useQuery(['appApiUrl'], () => getAppApiUrl(window.location.host));

    useEffect(() => {
        const apiUrl = getApiUrl();

        if (apiUrl) {
            setIsLoading(false);
        }

        if (query.data && query.data.url) {
            const url = query.data.url;

            setApiUrl(url + '/api/v4');
            setSocketUrl(url);
            setProxyUrl(url + '/proxy');

            setIsLoading(false);
        }

        if (query.error) {
            setIsLoading(false);
        }
    }, [query.data, query.error]);

    return {
        isLoading,
        isError: query.isError,
    };
};

export default useAppApiUrlData;
